import { Component, NgZone, OnInit, PipeTransform, TemplateRef, ViewChild } from '@angular/core';
import { DecimalPipe } from '@angular/common';
import { ListService } from 'src/app/shared/list-service.service';
import { ListComponent } from 'src/app/shared/list/list.component';

import { AG_GRID_LOCALE_EN } from '../../shared/list/locale/en.locale';
import { AG_GRID_LOCALE_ES } from '../../shared/list/locale/es.locale';
import { ActionsCellRenderer } from 'src/app/shared/list/renderer/actions-cell.renderer';
import { TranslateService } from '@ngx-translate/core';
import { MerchantService } from '../merchant.service';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { AuthService } from 'src/app/auth-module/auth.service';
import { faDownload, faHome } from '@fortawesome/free-solid-svg-icons';
import { environment } from 'src/environments/environment';
import { faFileExcel } from '@fortawesome/free-regular-svg-icons';

@Component({
  selector: 'app-merchant-report',
  templateUrl: './merchant-report.component.html',
  styleUrls: ['./merchant-report.component.css'],
  providers: [ListService, DecimalPipe]
})
export class MerchantReportComponent extends ListComponent implements OnInit {

  faHome = faHome;
  faDownload = faDownload;
  faFileExcel = faFileExcel;
	
  private gridApi;
	public gridOptions: any;
	public gridLocale;


	constructor(
		public service: MerchantService,
		public listService: ListService,
		public translateService: TranslateService,
		public auth: AuthService,
		private zone: NgZone,
	) {
		super(service, listService);
		this.setObject('merchant');
	}

	ngOnInit() {
		this.gridLocale = AG_GRID_LOCALE_EN;
		this.gridOptions = {
			defaultColDef: {
				resizable: true,
			},
			columnDefs: [
				{ headerName: '#', field: 'id', sortable: true, width: 60 },
				{ headerName: 'merchant.name', field: 'name', sortable: true, headerValueGetter: this.localizeHeader.bind(this) },
				{ headerName: 'merchant.merchant_type', field: 'merchant_type', sortable: true, headerValueGetter: this.localizeHeader.bind(this) },
				{ headerName: 'merchant.locations', field: 'locations', sortable: true, headerValueGetter: this.localizeHeader.bind(this) },
				{ headerName: 'merchant.coupons', field: 'coupons', sortable: true, headerValueGetter: this.localizeHeader.bind(this) },
				{ headerName: 'merchant.coupon_redemption', field: 'coupon_redemption', sortable: true, headerValueGetter: this.localizeHeader.bind(this) },
				{ headerName: 'merchant.rewards', field: 'rewards', sortable: true, headerValueGetter: this.localizeHeader.bind(this) },
				{ headerName: 'merchant.punches', field: 'punches', sortable: true, headerValueGetter: this.localizeHeader.bind(this) }
			]
		};

		this.loadData();
	}

	onFilterTextBoxChanged($event): void {
		this.gridApi.setQuickFilter($event.target.value);
	}

	onGridReady(params) {
		this.gridApi = params.api;
    	this.gridApi.refreshHeader();
		this.gridApi.sizeColumnsToFit();
		window.onresize = () => {
			this.gridApi.sizeColumnsToFit();
		}
	}

  loadData(){
    this.service.report().subscribe((data) => {
      this.data = data;
      this.listService.setData(data);
    }, (error) => {
      this.alertify.error(this.translate.instant('general.list.load_error'));
    });
  }

  public getExportUrlGeneral() {
    return environment.baseUrl + 'export/merchant';
  }


}
